import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Typography } from '@totalsoft/rocket-ui';
import { BackdropCustom, DialogTitle } from './DocumentsStyles';

function MessageBoxModal({ open, onConfirmation, onCloseModal, title, text }) {
  return (
    <Dialog
      id='message-box-dialog'
      open={open}
      onClose={onCloseModal}
      fullWidth
      maxWidth={'md'}
      BackdropComponent={BackdropCustom}
      transitionDuration={0}
      showX={false}
      disableBackdropClick
      disableEscapeKeyDown
      actionsProps={{ sx: theme => ({ px: theme.spacing(3), pb: theme.spacing(2) }) }}
      title={<DialogTitle>{title}</DialogTitle>}
      content={<Typography>{text}</Typography>}
      defaultActions
      onYes={onConfirmation}
    />
  );
}

MessageBoxModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default MessageBoxModal;
